import actions from "@/store/modules/auth/actions";
import mutations from "@/store/modules/auth/mutations";
import state from "@/store/modules/auth/state";

export default {
    actions,
    mutations,
    state
}